import { useState } from "react";
import { updateNote } from "../../api/notesApi";
import { SquarePen, Trash2 } from "lucide-react";

export default function NotesHistory({ notes, onDelete, fetchNotes, user_id }) {
  const [editingNote, setEditingNote] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleUpdateNote = async () => {
  
  const formattedDate = new Date(editingNote.appointment_date).toISOString().split('T')[0];

    try {
      await updateNote(editingNote.id, {
        user_id: user_id,
        preVisitNote: editingNote.preVisitNote,
        postVisitNote: editingNote.postVisitNote,
        appointment_date: formattedDate
      })

      setIsModalOpen(false);

      fetchNotes();
    } catch (error) {
      
    }
  }

  const handleEditClick = async (item) => {
    if (!item.id) {
      console.warn('Note ID missing', item);
      return;
    }

    setEditingNote(item);
    setIsModalOpen(true);
  }

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h2 className="text-xl font-bold text-[#04395b] mb-2">Notes History</h2>
      {notes.length === 0 ? (
        <p className="text-gray-500">No notes saved yet.</p>
      ) : (
        <ul className="space-y-3">
          {notes.map((item, index) => (
            <li key={index} className="bg-gray-50 shadow p-4 rounded-lg flex justify-between items-center">
              <div>
                <p className="text-sm text-gray-600 font-semibold">Date: {new Date(item.appointment_date).toLocaleDateString()}</p>
                {item.preVisitNote && (
                <div className="mt-2">
                  <p className="font-semibold text-gray-700">Pre-Visit Notes:</p>
                  <p className="text-gray-800">{item.preVisitNote}</p>
                </div>
              )}

              {item.postVisitNote && (
                <div className="mt-2">
                  <p className="font-semibold text-gray-700">Post-Visit Notes:</p>
                  <p className="text-gray-800">{item.postVisitNote}</p>
                </div>
              )}
              </div>

              <div className="flex gap-3 ml-6">
                <button
                  onClick={() => handleEditClick(item)}
                  className="text-sm p-2 bg-[#04395b] text-white rounded hover:bg-[#021724]"
                >
                  <SquarePen />
                </button>
                <button
                  onClick={() => onDelete(item.id)}
                  className="text-sm bg-gray-300 p-2 rounded hover:bg-gray-400"
                >
                  <Trash2 />
                </button>
              </div>

            </li>
          ))}
        </ul>
      )}

      {isModalOpen && editingNote && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white p-6 rounded shadow-lg w-96 space-y-3">
            <h3 className="text-xl font-bold">Edit Note</h3>
            <label className="block text-sm font-semibold text-gray-700">Appointment Date</label>
            <input
              type="date"
              value={editingNote.appointment_date}
              onChange={(e) => setEditingNote({ ...editingNote, appointment_date: e.target.value })}
              className="w-full border px-3 py-2 rounded"
            />

            <label className="block text-sm font-semibold text-gray-700">Pre-Visit Notes</label>
            <textarea
              value={editingNote.preVisitNote}
              onChange={(e) => setEditingNote({ ...editingNote, preVisitNote: e.target.value })}
              className="w-full border px-3 py-2 rounded"
              rows={4}
            />

            <label className="block text-sm font-semibold text-gray-700">Post-Visit Notes</label>
            <textarea
              value={editingNote.postVisitNote}
              onChange={(e) => setEditingNote({ ...editingNote, postVisitNote: e.target.value })}
              className="w-full border px-3 py-2 rounded"
              rows={4}
            />
            <div className="flex justify-end space-x-2">
              <button onClick={() => setIsModalOpen(false)} className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">Cancel</button>
              <button onClick={handleUpdateNote} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Save</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
